import Cookies from "js-cookie";

export function getCurrentHousehold() {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/household';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response.ok ? response.json() : null;
    });
}

export function createHousehold(name: string) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/household';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({'name': name})
    });
}

export function leaveHousehold() {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/household';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}

export function removeHouseholdMember(username: string) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/household/members/' + username;
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}

export function inviteToHousehold(username: string) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/household/invitations';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({'username': username})
    });
}

export function getPendingInvitations() {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/household/invitations';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'GET',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    }).then(response => {
        return response.ok ? response.json() : [];
    });
}

export function acceptInvitation(invitationId: number) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/household/invitations/' + invitationId + '/accept';
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}

export function declineInvitation(invitationId: number) {
    const api_path: string = process.env.REACT_APP_BASE_PATH + '/household/invitations/' + invitationId;
    const token: string | undefined = Cookies.get('token');
    return fetch(api_path, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}
